import { tz } from "@date-fns/tz";
import { endOfMonth, format, isBefore, startOfDay } from "date-fns";

const UTC_DATE_CONTEXT = { in: tz("UTC") };
const DATE_ONLY_FORMAT = "yyyy-MM-dd";

export const generateAvailabilityInterval = (initialDate = new Date()) => {
  const today = startOfDay(new Date(), UTC_DATE_CONTEXT);

  const candidateStartDate = startOfDay(initialDate, UTC_DATE_CONTEXT);

  let startDate = candidateStartDate;

  if (isBefore(candidateStartDate, today)) {
    startDate = today;
  }

  const endDate = endOfMonth(startDate, UTC_DATE_CONTEXT);

  return {
    start: format(startDate, DATE_ONLY_FORMAT, UTC_DATE_CONTEXT),
    end: format(endDate, DATE_ONLY_FORMAT, UTC_DATE_CONTEXT),
  };
};
